import { formatDate } from 'src/components/atoms/format-date';
import { dateFormats } from 'src/utils/date-formats';

export const formatSpaceBlockingDateRange = (from: number, until: number) =>
  `${formatDate(new Date(from), `${dateFormats.day} ${dateFormats.monthShort} ${dateFormats.year} ${dateFormats.hours}:${dateFormats.minutes}`)} - ${formatDate(new Date(until), `${dateFormats.day} ${dateFormats.monthShort} ${dateFormats.year} ${dateFormats.hours}:${dateFormats.minutes}`)}`;
